import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Language, LanguageMenuItem } from "../types/index.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  isPreview: boolean;
  items: LanguageMenuItem[];
  languageId: Language;
}

const translations = {
  de: { selectLanguage: "Sprache wählen" },
  it: { selectLanguage: "selezionare lingua" },
  en: { selectLanguage: "select language" },
  fr: { selectLanguage: "sélectionner la langue" },
};

const LanguageMenuSelect: FunctionComponent<Props> = ({
  isPreview,
  items,
  languageId,
}) => {
  const languageIds = items.map(({ hrefLang }) => hrefLang);
  const index = languageIds.indexOf(languageId);
  const [selectedIndex, setSelectedIndex] = useState(index);
  const lastSelectedIndex = useRef(index);
  const history = isPreview && useHistory();
  const i18n = getTranslations(languageId, translations);

  useEffect(() => {
    // Only go to a new URL if a different language was selected
    if (selectedIndex === lastSelectedIndex.current) return;
    lastSelectedIndex.current = selectedIndex;

    // non existent menu item should not be possible
    const menuItem = items[selectedIndex];
    if (!menuItem) return;

    const { href } = menuItem;
    history ? history.push(href) : (location.href = href);
  }, [selectedIndex]);

  return (
    <div className="LanguageMenu__Inner">
      <Icon
        className="LanguageMenu__Icon LanguageMenu__Icon--front"
        glyph="language"
      />
      <span className="LanguageMenu__SelectedItem">
        {items[selectedIndex]?.children}
        <Icon
          className="LanguageMenu__Icon LanguageMenu__Icon--dropdown"
          glyph="arrow-down"
        />
      </span>
      <select
        value={selectedIndex}
        className="LanguageMenu__Select"
        aria-label={i18n.selectLanguage}
        onChange={(e) => {
          const value = +e.target.value;
          value !== selectedIndex && setSelectedIndex(value);
        }}
      >
        {items.map(({ href, children }, index) => {
          return (
            <option
              className="LanguageMenu__SelectOption"
              key={href}
              value={index}
            >
              {children}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default LanguageMenuSelect;
